import React, { useState, useCallback } from 'react';
import './App.css';
import Tabs from './Tabs';
import ProtectedRoute from './components/ProtectedRoute';
import UserProfile from './components/UserProfile';
import { authService } from './services/authService';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const handleAuthChange = useCallback((authenticated) => {
    setIsAuthenticated(authenticated);
    if (authenticated) {
      setUser(authService.getUser());
    } else {
      setUser(null);
    }
  }, []);

  const handleSignOut = useCallback(() => {
    setIsAuthenticated(false);
    setUser(null);
  }, []);

  return (
    <div className="App">
      {/* Header with Logo and User Profile */}
      <header className="App-logo">
        <div className="logo-container">
          <h1>AI CardioMeter</h1>
        </div>
        {isAuthenticated && user && (
          <UserProfile user={user} onSignOut={handleSignOut} />
        )}
      </header>

      {/* Main Content Area */}
      <main className="main-content">
        <ProtectedRoute onAuthChange={handleAuthChange}>
          <Tabs />
        </ProtectedRoute>
      </main>
    </div>
  );
};

export default App;